import OrderStepsSection from "./sections/orderStepsSection";
export default function orderSteps() {
    const sections = document.querySelectorAll('[data-order-steps]')
    sections.forEach(section => new OrderStepsSection(section));
}